/* ActivityViewRenderer.js */

"use strict";
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const BaseActivityViewRender = require("../../../../lib/activity/BaseActivityViewRender");
const Registrations = require("../../../../../RegistrationNamespaces");

class ActivityViewRenderer extends BaseActivityViewRender {
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    render() {
        return this._model.whenModelIsReady().then(() => {
            this._activityGrid = new EntityGrid({
                gridKey: this._model._gridKey,
                columns: this._model.columnConfig,
                pagingFeed: this._model._activityFeed,
                showHeader: true,
                columnOrder: ["activityType", "snapshot", "description", "status", "actions"]
            });

            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._activityGrid.renderer.rootElement);
            }
            this._registerListeners();
            this._renderGridRows();
            this._hideDownloadViewAction();
        });
    }

    _switchToLogView(rowId) {
        this.model.gameEditor.setActiveView(
            Registrations.OS_PLAN_EDITOR_SUBVIEW_ACTIVITY_LOGS,
            [
                {
                    value: {
                        fqn: Registrations.OS_PLAN_EDITOR_VIEW_ACTIVITY
                    },
                    content: "Activity",
                    left: {
                        arrow: {
                            direction: "left"
                        }
                    }
                }
            ],
            {
                logId: rowId
            }
        );
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ActivityViewRenderer;
